import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("../pages/index.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../pages/home/home.vue"),
  },
  {
    path: "/person_data",
    name: "person_data",
    component: () => import("../pages/home/person_data.vue"),
  },
  {
    path: "/student",
    name: "student",
    component: () => import("../pages/student/student.vue"),
  },
  {
    path: "/student_list",
    name: "student_list",
    component: () => import("../pages/student/student_list.vue"),
  },
  {
    path: "/learn_list",
    name: "learn_list",
    component: () => import("../pages/student/learn_list.vue"),
  },
  {
    path: "/teacher",
    name: "teacher",
    component: () => import("../pages/teacher/teacher.vue"),
  },
  {
    path: "/teacher_list",
    name: "teacher_list",
    component: () => import("../pages/teacher/teacher_list.vue"),
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../pages/admin/admin.vue"),
  },
  {
    path: "/about_work",
    name: "about_work",
    component: () => import("../pages/about_work/about_work.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../pages/product/product.vue"),
  },
  {
    path: "/active_index",
    name: "active_index",
    component: () => import("../pages/active_manage/active_index.vue"),
  },
  {
    path: "/active_end",
    name: "active_end",
    component: () => import("../pages/active_manage/active_end.vue"),
  },
  {
    path: "/admin_manage",
    name: "admin_manage",
    component: () => import("../pages/admin/admin_manage.vue"),
  },
  {
    path: "/class_manage",
    name: "class_manage",
    component: () => import("../pages/class_manage/class_manage.vue"),
  },
  {
    path: "/school_manage",
    name: "school_manage",
    component: () => import("../pages/school_manage/school_manage.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../pages/login/login.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
